// @flow
import { Button, Grid2, TextField } from "@mui/material";
import { isEmpty } from "lodash-es";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import Modal from "../../../../../components/modals/modal.mesf";
import { HelmetDexteel } from "../../../../../helmet/HelmetDexteel";
import { setPassword } from "../../repositories/UsersRepository";

type Props = {
	show: boolean;
	userId: number | null;
	onHide: (shouldUpdate: boolean) => void;
	suffixTitle?: string;
};
export const ChangePassword = ({
	show,
	userId,
	onHide,
	suffixTitle,
}: Props) => {
	const [password, setPasswordText] = useState("");
	const [isDirty, setIsDirty] = useState(false);

	const handleSubmit = useCallback(
		async (ev: React.FormEvent<HTMLFormElement>) => {
			ev.preventDefault();
			const resp = await setPassword(userId!, password);
			onHide(true);
		},
		[userId, password],
	);

	useEffect(() => {
		if (show) {
			setPasswordText("");
			setIsDirty(false);
		}
	}, [show]);

	if (userId) {
		return (
			<>
				{show && (
					<HelmetDexteel
						title={`Change Password${suffixTitle ? ` - ${suffixTitle}` : ""}`}
					/>
				)}
				<Modal
					title={`Change password`}
					open={show}
					handleClose={() => onHide(false)}
					maxWidth="lg"
				>
					<Grid2 container>
						<Grid2 size={{ md: 12, xs: 12 }}>
							<Modal.Content style={{ padding: "6px 16px 16px" }}>
								<form onSubmit={handleSubmit}>
									<Grid2 size={{ md: 12, xs: 12 }}>
										<TextField
											label="New Password"
											value={password}
											onChange={(el) => {
												setIsDirty(true);
												setPasswordText(el.target.value);
											}}
											variant="outlined"
											error={isEmpty(password) && isDirty}
											fullWidth
											// margin="dense"
											autoComplete="off"
										/>
									</Grid2>

									<Grid2 size={{ md: 12, xs: 12 }} style={{ marginTop: 15 }}>
										<Button
											fullWidth
											variant="contained"
											color="primary"
											type={"submit"}
										>
											APPLY
										</Button>
									</Grid2>
								</form>
							</Modal.Content>
						</Grid2>
					</Grid2>
				</Modal>
			</>
		);
	} else {
		return <></>;
	}
};
